import { useParams } from "react-router-dom";

import { PaginationProvider } from "../../providers/PaginationProvider/PaginationProvider";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { FlexPackHolders } from "../../components/UnifiedSearchList/FlexPackHolders";

export default function FlexPackHoldersPage() {
  const { uuid } = useParams();

  return (
    <PaginationProvider>
      <ModalProvider>
        <FlexPackHolders uuid={uuid} />
      </ModalProvider>
    </PaginationProvider>
  );
}
